import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAccountStorageInfoQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
}>;


export type GetAccountStorageInfoQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, mountedStorageEnabled: boolean, disabledFeatures?: { __typename?: 'DisabledFeatures', mountedStorage: boolean } | null, subscription: { __typename?: 'AccountSubscription', id: string, tier: Types.AccountTier, subscriptionEndAt?: string | null, addOns?: Array<{ __typename?: 'AddOn', id: string, increment: number, modifier: string, quantity: number }> | null, limitedResources?: { __typename?: 'LimitedResources', storageBytes?: { __typename?: 'LimitedResource', balance53?: number | null, limit53?: number | null, preventOverage?: boolean | null, used53?: number | null } | null, mountedStorageBytes?: { __typename?: 'LimitedResource', balance53?: number | null, limit53?: number | null, preventOverage?: boolean | null, used53?: number | null } | null, archivedStorageBytes?: { __typename?: 'LimitedResource', limit53?: number | null, used53?: number | null } | null } | null, perUserStorage?: { __typename?: 'AccountSubscriptionPerUserStorage', seats: number, increment: number, limit: number } | null, plan?: { __typename?: 'Plan', id: string, activeStorageLimit?: number | null, mountedStorageLimit?: number | null, mountedStorageTrialLimit?: number | null } | null, trial: { __typename?: 'SubscriptionTrial', isActive: boolean } }, usage: { __typename?: 'AccountUsage', standardStorage?: { __typename?: 'StorageUsage', projectCount?: number | null } | null, mountedStorage?: { __typename?: 'StorageUsage', projectCount?: number | null } | null } } | null };


export const GetAccountStorageInfo = /*#__PURE__*/ gql`
    query GetAccountStorageInfo($accountId: ID!) {
  account(accountId: $accountId) {
    id
    disabledFeatures {
      mountedStorage
    }
    mountedStorageEnabled
    subscription {
      id
      addOns {
        id
        increment
        modifier
        quantity
      }
      limitedResources {
        storageBytes {
          balance53
          limit53
          preventOverage
          used53
        }
        mountedStorageBytes {
          balance53
          limit53
          preventOverage
          used53
        }
        archivedStorageBytes {
          limit53
          used53
        }
      }
      perUserStorage {
        seats
        increment
        limit
      }
      plan {
        id
        activeStorageLimit
        mountedStorageLimit
        mountedStorageTrialLimit
      }
      tier
      trial {
        isActive
      }
      subscriptionEndAt
    }
    usage {
      standardStorage {
        projectCount
      }
      mountedStorage {
        projectCount
      }
    }
  }
}
    ` as unknown as DocumentNode<GetAccountStorageInfoQuery, GetAccountStorageInfoQueryVariables>;

          

          export const useGetAccountStorageInfoQuery = (options?:QueryHookOptions<GetAccountStorageInfoQuery, GetAccountStorageInfoQueryVariables>) => useQuery(GetAccountStorageInfo, options);

          

          export type GetAccountStorageInfoQueryOptions = QueryHookOptions<GetAccountStorageInfoQuery, GetAccountStorageInfoQueryVariables>;

          

          export const useGetAccountStorageInfoLazyQuery = (options?:LazyQueryHookOptions<GetAccountStorageInfoQuery, GetAccountStorageInfoQueryVariables>) => useLazyQuery(GetAccountStorageInfo, options);

          

          export type GetAccountStorageInfoQueryResult = ReturnType<typeof useGetAccountStorageInfoQuery>;

          
